import { Visit } from '../types/visit';

// Update a visit
export async function updateVisit(visit: Visit): Promise<Visit> {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // In a real app, this would be an API call
  // For now, just return the updated visit
  return {
    ...visit,
    // Remove the updatedAt property as it's not part of the Visit type
  };
}

// Get a single visit
export async function getVisit(id: string): Promise<Visit> {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Mock data
  return {
    id,
    patientId: '1',
    clinicId: '1',
    doctorId: '1',
    startTime: new Date().toISOString(),
    endTime: new Date().toISOString(),
    type: 'regular',
    status: 'in-progress',
    title: 'John Doe - Regular Check-up',
    notes: 'Patient reported mild symptoms',
    vitals: {
      temperature: 37.2,
      bloodPressure: '120/80',
      heartRate: 72,
      respiratoryRate: 16,
    },
    symptoms: ['Headache', 'Fatigue'],
    diagnosis: 'Mild viral infection',
    prescriptions: [
      {
        medication: 'Paracetamol',
        dosage: '500mg',
        frequency: 'Every 6 hours',
        duration: '3 days',
        notes: 'Take as needed for pain/fever'
      }
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    duration: 30, // in minutes
    reason: 'Regular Check-up'
  };
}
